import { Fragment } from "react";
import { useThemeStore } from "../../stores/themeStore";
import StartEssay from "../../../Essay/pages/start_essay";
import { useParams } from "react-router-dom";

export default function EssayInit() {
  const { slug } = useParams();
  const { theme } = useThemeStore();

  return (
    <Fragment>
      <StartEssay isCourse={true} slug={theme?.slug} course={slug}/>
    </Fragment>
  )
}
